controllers.controller('UploadDocumentsCategoriesController', [
    '$scope', '$state', '$stateParams', 'LocaleService', 'constants',
    function ($scope, $state, $stateParams, LocaleService, Const) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.categoryName = $stateParams.categoryName;
        $scope.categoryVideoLink = $stateParams.categoryVideoLink;

        $scope.documents = Const.documentTypes;
        $scope.baseCategories = getBaseCategoriesByCategory($scope.categoryName);

        function getDocumentsByCategory(category) {
            return $scope.documents
                .filter(function (document) {
                    return document.category === category
                })
        }

        function getBaseCategoriesByCategory(category) {
            return getDocumentsByCategory(category)
                .map(function (document) {
                    return document.baseCategory
                })
                .filter(function (item, index, sourceArray) {
                    return sourceArray.indexOf(item) == index
                })
        }
    }]);
